export const licensesTableHeaders = [
  {
    text: 'Registered Accounts',
    value: 'email',
    class: 'bg-table-heading table-header-first',
    width: '250px',
  },
  {
    text: 'Allow Guests',
    value: 'numOfAllowedCasuals',
    align: 'center',
    class: 'bg-table-heading table-header-last',
    width: '100px',
    sortable: false,
  },
]
